import { transformUnits } from '@/helpers/unit-formatter/unit-formatter';
import { FormattedUnitLabels, UnitValue } from '@/helpers/unit-formatter/unit-formatter.types';
import {
  clampDegrees,
  degreesToWindDirection,
  toNumber,
  unitValueToFormattedUnitLabels,
} from '@/helpers/unit-formatter/unit-formatter.utils';

/**
 * Formatter for wind direction display values.
 *
 * - `valueLabel`: degrees rounded to the nearest integer and clamped to 0–360.
 * - `unitsLabel` cardinal: derived via `degreesToWindDirection` 8-point compass mapping.
 */
export const formatDirection = (
  unitValue: UnitValue,
  displayUnits?: string
): FormattedUnitLabels => {
  const transformed = transformUnits(unitValue, displayUnits);
  const value = toNumber(transformed.value);

  if (value == null) {
    return unitValueToFormattedUnitLabels({ value: transformed.value, units: undefined });
  }

  const rounded = clampDegrees(value);
  const cardinal = degreesToWindDirection(rounded);
  const unitsLabel = `° ${cardinal}`;

  return {
    valueLabel: `${rounded}`,
    unitsLabel,
    valueUnitsLabel: `${rounded}${unitsLabel}`,
  };
};
